export enum ConfigViewType {
  boolean = 'Boolean',
  button = 'Button',
  commonModuleVersionDropDown = 'CommonModuleVersionDropDown',
  condition = 'Condition',
  dropdown = 'Dropdown',
  dtmfDropDown = 'DtmfDropDown',
  exitComponent = 'ExitComponent',
  formListDropDown = 'FormListDropDown',
  formVersionsDropDown = 'FormVersionsDropDown',
  function = 'Function',
  hr = 'hr',
  input = 'Input',
  intentDropdown = 'IntentDropdown',
  itemList = 'ItemList',
  label = 'Label',
  jsx = 'Jsx',
  keySwitch = 'KeySwitch',
  keyValue = 'KeyValue',
  menu = 'menu',
  moduleParamDropdown = 'ModuleParamDropdown',
  nestedProperties = 'NestedProperties',
  plavSavedPromptKeyDropdown = 'PlavSavedPromptKeyDropdown',
  promptDropdown = 'PromptDropdown',
  promptTextarea = 'PromptTextarea',
  scopeHint = 'ScopeHint',
  slider = 'Slider',
  switch = 'Switch',
  tagList = 'TagList',
  textarea = 'Textarea',
  wrappedItemList = 'WrappedItemList'
}
